import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import UserManagementForm from "@/components/forms/user-management/UserManagementForm";

interface UserManagementDialogProps {
    open: boolean;
    onOpenChange: (open: boolean) => void;
    user?: any;
    mode?: "create" | "edit";
}

const UserManagementDialog = ({ open, onOpenChange, user, mode = "create" }: UserManagementDialogProps) => {
    const isEditing = mode === "edit" && user;

    return (
        <Dialog open={open} onOpenChange={onOpenChange}>
            <DialogContent className="max-w-md md:max-w-2xl lg:max-w-4xl xl:max-w-6xl">
                <DialogHeader>
                    <DialogTitle>{isEditing ? "Edit User" : "Create New User"}</DialogTitle>
                    <DialogDescription>
                        {isEditing
                            ? "Update user information, role, and permissions."
                            : "Add a new user to the system with appropriate role and permissions."}
                    </DialogDescription>
                </DialogHeader>
                <UserManagementForm user={user} mode={mode} onSuccess={() => onOpenChange(false)} />
            </DialogContent>
        </Dialog>
    );
};

export default UserManagementDialog;
